import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/api';

export default function AmcBanner() {
  const [amc, setAmc] = useState(null);

  useEffect(() => {
    apiFetch('/auth/amc-status')
      .then(r => { if (r?.amc) setAmc(r.amc); })
      .catch(() => {});
  }, []);

  if (!amc) return null;

  const dateStr = new Date(amc.end_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

  if (amc.expired) {
    return (
      <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 10, padding: '12px 18px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 20 }}>⚠️</span>
        <div>
          <p style={{ fontSize: 14, fontWeight: 700, color: '#b91c1c', margin: 0 }}>
            Your AMC has ended on {dateStr}.
          </p>
          <p style={{ fontSize: 13, color: '#dc2626', margin: '2px 0 0' }}>
            You can still raise tickets, but please contact us to renew your AMC for continued support coverage.
          </p>
        </div>
      </div>
    );
  }

  if (amc.expiring_soon) {
    return (
      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '12px 18px', marginBottom: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 20 }}>🔔</span>
        <div>
          <p style={{ fontSize: 14, fontWeight: 700, color: '#92400e', margin: 0 }}>
            AMC ending on {dateStr} — {amc.days_left} day{amc.days_left !== 1 ? 's' : ''} remaining.
          </p>
          <p style={{ fontSize: 13, color: '#b45309', margin: '2px 0 0' }}>
            Please contact us to renew before your coverage expires.
          </p>
        </div>
      </div>
    );
  }

  return null;
}
